// extracted by mini-css-extract-plugin
module.exports = {"onboarding":"RegistrationStepsHandler_onboarding__29bng","page":"RegistrationStepsHandler_page__xpWTH"};